import { boolean, object, string } from "yup";

import {
  optionalPhoneNumber,
  sequoiaEmail,
  sequoiaPhoneNumber,
} from "@covertree/utils";

export interface ContactDetailsForm {
  emailAddress?: string;
  noEmail?: boolean;
  physicallyMailDocuments?: boolean;
  primaryContactNumber: string;
  secondaryContactNumber?: string;
}

export const contactDetailsFormValidator = (isBookConversion: boolean) =>
  object({
    emailAddress: string().when("noEmail", ([noEmail]) => {
      if (noEmail) return string().optional();
      return sequoiaEmail(isBookConversion);
    }),
    noEmail: boolean().optional(),
    physicallyMailDocuments: boolean().when("noEmail", ([noEmail]) =>
      noEmail === true ? boolean().required().isTrue() : boolean().optional()
    ),
    primaryContactNumber: sequoiaPhoneNumber(isBookConversion),
    secondaryContactNumber: optionalPhoneNumber(),
  });
